import React from 'react'
import styles from './Event.module.scss'
import ReactMarkdown from 'react-markdown'

export default function Event({ image, title, description, date }) {
  return (
    <div className={styles.event}>
      <div className={styles.event__info}>
        <h2 className={styles.event__title}>{title}</h2>
        <p className={styles.event__date}>{date}</p>
        <div className={styles.event__descriptionContainer}>
          <ReactMarkdown className={styles.event__description}>{description}</ReactMarkdown>
        </div>
      </div>
      {image && <img src={image} alt={title} className={styles.event__image}/>}
    </div>
  )
}